<template>
    <div>
        <Card>
            <Card>
                <p slot="title">{{t.post.searchName}}</p>
                <Form :model="formItem" :label-width="100" label-position="right">
                    <Row :gutter="16">
                        <Col span="8">
                            <Form-item :label="t.post.name">
                                <Input v-model="formItem.name"
                                       :placeholder="msgUtil.placeholderRequired(t.post.name)"></Input>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Form-item :label="t.post.code">
                                <Input v-model="formItem.code"
                                       :placeholder="msgUtil.placeholderRequired(t.post.code)"></Input>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Form-item :label="t.post.status">
                                <Select v-model="formItem.status" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderSelected(t.post.status)">>
                                    <Option value="1">{{t.post.open}}</Option>
                                    <Option value="0">{{t.post.close}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="8" class="">
                            <Form-item :label="t.post.createStartTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createStartTime" style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderSelected(t.post.createStartTime)"
                                            :options="createStartTimeOption"
                                            @on-change="onStartTimeChange"></DatePicker>
                            </Form-item>
                        </Col>
                        <Col span="8" class="">
                            <Form-item :label="t.post.createEndTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createEndTime" style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderSelected(t.post.createEndTime)"
                                            :options="createEndTimeOption" @on-change="onEndTimeChange"></DatePicker>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Button type="primary" icon="ios-search" style="float: right;" @click="search(true)">
                                {{msgUtil.message.action.search}}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Row class="margin-top-10">
                <Col span="12">
                    <sort-button-group :buttons="sortButton" @on-order="orderClick"/>
                </Col>
                <Col style="text-align:right;" span="12">
                    <!-- name 是路由名，参考的@/router/organization/post.js的名 -->
                    <Button icon="md-add" to="./add">{{msgUtil.message.action.add}}</Button>
                    <Button icon="ios-trash" @click="delAll">{{msgUtil.message.action.deleteAll}}</Button>
                </Col>
            </Row>
            <Row class="margin-top-10">
                <Table ref="selection" :context="self" :columns="columns" :data="data" :loading="loading"
                       @on-selection-change="rowSelect"></Table>
            </Row>
            <Row class="margin-top-10" type="flex" justify="end">
                <Page ref="page" :total="total" show-total show-sizer @on-change="pageChange"
                      @on-page-size-change="pageSizeChange">
                    {{msgUtil.message.page.total}} {{ total }} {{msgUtil.message.page.paper}}
                </Page>
            </Row>
        </Card>
    </div>
</template>
<script>
import { Message } from 'iview';
import { del, delAll, getPostList } from '@/api/post';
import sortButtonGroup from '@/components/sort-button-group.vue';

export default {
    name: 'organization_post_list',
    components: {
        sortButtonGroup,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        const renderSortOrder = (h, params) => {
            const row = params.row;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                    },
                },
                row.sortOrder
            );
        };
        const renderStatus = (h, params) => {
            const row = params.row;
            const color = row.status === '0' ? 'error' : row.status === '1' ? 'success' : 'error';
            const text = row.status === '0' ? t.post.close : row.status === '1' ? t.post.open : t.post.close;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                        color: color,
                    },
                },
                text
            );
        };
        const renderPost = (h, params) => {
            const row = params.row;
            return h('div', [
                h(
                    'router-link',
                    {
                        props: {
                            to: './detail/' + row.id,
                        },
                    },
                    row.name
                ),
            ]);
        };

        const renderAction = (h, params) => {
            const row = params.row;
            return h('button-group', [
                h(
                    'i-button',
                    {
                        props: {
                            type: 'primary',
                            size: 'small',
                            to: './edit/' + row.id,
                        },
                    },
                    msgUtil.message.action.edit
                ),
                h(
                    'i-button',
                    {
                        props: {
                            type: 'error',
                            size: 'small',
                            style: 'margin-left:5px',
                        },
                        on: {
                            click: this.del.bind(this, row.id),
                        },
                    },
                    msgUtil.message.action.delete
                ),
            ]);
        };
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            formItem: {
                name: '',
                code: '',
                sortOrder: 0,
                status: '',
                createBy: '',
                createTime: '',
                createStartTime: '',
                createEndTime: '',
                oa: '',
                od: '',
                current: 1,
                size: 10,
            },
            createStartTimeOption: {},
            createEndTimeOption: {},
            selectIds: [],
            data: [],
            total: 0,
            columns: [
                { title: '', type: 'selection', align: 'center', width: 44 },
                { title: t.table.id, key: 'id', align: 'center', width: 164 },
                { title: t.table.name, key: 'name', align: 'center', tooltip: true, render: renderPost },
                { title: t.table.code, key: 'code', align: 'center', tooltip: true },
                { title: t.table.sortOrder, key: 'sortOrder', align: 'center', render: renderSortOrder },
                { title: t.table.createBy, key: 'createBy', tooltip: true },
                { title: t.table.createTime, key: 'createTime', width: 150 },
                {
                    title: t.table.status,
                    key: 'status',
                    align: 'center',
                    width: 100,
                    render: renderStatus,
                },
                {
                    title: msgUtil.message.action.name,
                    key: 'operation',
                    align: 'center',
                    width: 130,
                    fixed: 'right',
                    render: renderAction,
                },
            ],
            // 排序btn
            sortButton: [
                { key: 'name', value: t.post.name, order: 0 },
                { key: 'sortOrder', value: t.post.sortOrder, order: 0 },
                { key: 'createTime', value: t.post.createTime, order: 0 },
            ],
            loading: false,
        };
    },
    methods: {
        //排序
        async orderClick(btn) {
            this.formItem.oa = '';
            this.formItem.od = '';
            if (btn.order === 1) {
                this.formItem.oa = btn.key;
            } else if (btn.order === 2) {
                this.formItem.od = btn.key;
            }
            await this.search(true);
        },
        //数据检索
        async search(flg) {
            if (flg) {
                this.formItem.current = 1;
                this.$refs.page.currentPage = 1;
            }
            this.loading = true;
            await this.getCreateTime();
            //console.log(this.formItem);
            const result = await getPostList(this.formItem);
            //console.log(result);
            if (result) {
                this.data = result.page.records;
                this.total = result.page.total;
            }
            this.loading = false;
        },
        //创建时间作成
        async getCreateTime() {
            this.formItem.createTime = '';
            if (this.formItem.createStartTime !== '' && this.formItem.createStartTime !== undefined) {
                this.formItem.createTime = this.formItem.createStartTime + ',';
            }
            if (this.formItem.createEndTime !== '' && this.formItem.createEndTime !== undefined) {
                if (this.formItem.createStartTime === '' || this.formItem.createStartTime === undefined) {
                    this.formItem.createTime = ',';
                }
                this.formItem.createTime += this.formItem.createEndTime;
            }
        },
        // 页号改变
        async pageChange() {
            this.formItem.current = this.$refs.page.currentPage;
            await this.search(false);
        },
        // 每页显示数据
        async pageSizeChange() {
            this.formItem.size = this.$refs.page.currentPageSize;
            await this.search(false);
        },
        // 删除
        async del(id) {
            await del(id);
            await this.search(true);
        },
        // 批量删除
        async delAll() {
            if (this.selectIds.length == 0) {
                Message.error({
                    content: this.msgUtil.message.warn.notSelectedRow,
                    duration: 60,
                    closable: true,
                });
                return;
            }
            await delAll(this.selectIds);
            await this.search(true);
        },
        // 行选择
        rowSelect(selection) {
            this.selectIds = selection.map(p => {
                return { id: p.id };
            });
        },
        /**
         * 开始时间发生变化时触发,设置结束时间不可选择的日期
         * 结束时间应大于等于开始时间,且小于等于当前时间
         * @param {string} startTime 格式化后的日期
         * @param {string} type 当前的日期类型
         */
        onStartTimeChange(startTime) {
            this.formItem.createStartTime = startTime;
            this.createEndTimeOption = {
                disabledDate(endTime) {
                    return endTime < new Date(startTime) || endTime > Date.now();
                },
            };
        },
        /**
         * 结束时间发生变化时触发,设置开始时间不可选择的日期
         * 开始时间小于等于结束时间,且小于等于当前时间
         * @param {string} date 格式化后的日期
         * @param {string} type 当前的日期类型
         */
        onEndTimeChange(endTime) {
            this.formItem.createEndTime = endTime;
            this.createStartTimeOption = {
                disabledDate(startTime) {
                    return startTime > new Date(endTime) || startTime > Date.now();
                },
            };
        },
    },
    async mounted() {
        await this.search(true);
    },
};
</script>
<style>
</style>
